import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpMainNavigationComponent from './adpMainNavigation.component';

let adpMainNavigationModule = angular.module('adpMainNavigation', [
  uiRouter
])

.component('adpMainNavigation', adpMainNavigationComponent)

.name;

export default adpMainNavigationModule;



// WEBPACK FOOTER //
// ./src/app/components/adpMainNavigation/adpMainNavigation.js